import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/shipd_showcase.mp4'


const _withScopeId = n => (_pushScopeId("data-v-95848d1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wrapper" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Increase your productivity with ease"),
  /*#__PURE__*/_createElementVNode("video", {
    muted: "",
    loop: "",
    controls: "",
    src: _imports_0
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}